module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_vestland_pos.a6667616.pdf";